var map = {
	"./WeChat-Pay.svg": "3vTU",
	"./activity.svg": "9pJD",
	"./add-user.svg": "J/sq",
	"./agent.svg": "Liw6",
	"./apartment.svg": "KDZB",
	"./authorization-list.svg": "P5Zq",
	"./avatar.svg": "SlSe",
	"./back.svg": "RN8c",
	"./cancel-authorization.svg": "44ET",
	"./config-router.svg": "ypmP",
	"./consumption-card.svg": "IxgZ",
	"./dashboard.svg": "BCGP",
	"./diamond.svg": "qpb/",
	"./edit.svg": "ql+d",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./id-bound.svg": "UN03",
	"./international.svg": "SBEl",
	"./kefu.svg": "9NZN",
	"./language.svg": "+Dip",
	"./leaf.svg": "a0f/",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./logout.svg": "KvOj",
	"./maintain.svg": "YWMt",
	"./menu.svg": "dH9r",
	"./military-exploits.svg": "vHLw",
	"./nested.svg": "798r",
	"./operating-data.svg": "zoyW",
	"./order-inquiry.svg": "TTFj",
	"./password.svg": "QjmH",
	"./register.svg": "7aQc",
	"./reissue.svg": "tyXU",
	"./role-authorization.svg": "1s+B",
	"./rule.svg": "6GtT",
	"./size.svg": "Cr4N",
	"./table.svg": "oSYw",
	"./tea-house.svg": "5w3c",
	"./theme.svg": "hdtf",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 3